import  { Link }  from 'i18n/navigation'
import {useSelectedLayoutSegment} from 'next/navigation';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function OSSNavLink(props: any) {
  const { children, path } = props;

  const selectedLayoutSegment = useSelectedLayoutSegment();
  const pathname = selectedLayoutSegment ? `/${selectedLayoutSegment}` : '/';
  const isActive = pathname === path;

 return (
      <Link className="nav-link"  tabIndex={0} role="button" style={{fontWeight: isActive ? 'bold' : 'normal'}} href={`${path}`}>
        {children}
      </Link>
    );

/*
  
  if (isActive) {
    return (
      <Link className="nav-link" aria-current="page" tabIndex={0} role="button" style={{fontWeight: isActive ? 'bold' : 'normal'}} href={`${path}`}>
        {children}
      </Link>
    )
  } else {
    return (
      <Link className="nav-link"  tabIndex={0} role="button" style={{fontWeight: isActive ? 'bold' : 'normal'}} href={`${path}`}>
        {children}
      </Link>
    );
  }
    */
}
